@if (immediateContactDetails) {
  <div>
    <p-panel header="Immediate Contact Details">
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data p-form-aligned">
        <div class="mb-4 md:col-span-12 ml-2 p-0 ml-2">
          <p>{{ isInternal
            ? 'If available, enter the contact name and phone of a representative to contact if necessary.'
            : 'Please provide the contact information for a Carelon representative to reach out to you or a delegate, if necessary.' }}
          </p>
        </div>
        <div class="col-span-6">
          <div class="field">
            <label data-test-id="immediate-name-label">Contact's Name: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ immediateContactDetails.contactName || '--' }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6">
          <div class="field">
            <label data-test-id="immediate-phone-label">Contact's Phone: </label>
            <div class="p-field-value">
              <div class="readonly-field p-text-nowrap truncate">
                {{ immediateContactDetails.contactPhone | phoneNumber }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6">
          <div class="field">
            <label data-test-id="immediate-fax-label">Contact's Fax: </label>
            <div class="p-field-value">
              <div class="readonly-field p-text-nowrap truncate">
                {{ immediateContactDetails.contactFax | phoneNumber }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6">
          <div class="field">
            <label data-test-id="immediate-phone-extension-label">Contact's Phone Extension: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ immediateContactDetails.contactPhoneExtension || '--' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-message
        severity="warn"
        text="Fax numbers submitted here will be used to send PHI, authorizations, and clinical requests."
      ></p-message>
    </p-panel>
  </div>
}
